import designTokens from '@customink/design-tokens/build/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: designTokens.typography.body.long1.size.value,
                    lineHeight: designTokens.typography.body.long1.lineHeight.value,
                    color: designTokens.color.gray.limestone.value,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    marginLeft: 0,
                    marginTop: '.125rem',
                    transform: 'scale(1)',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=formHelperTextTheme.js.map